import styled from 'styled-components';

export const SDeleteConfirmation = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 2rem;
`;
